import React, { useState, useEffect } from "react";
import "../FlightResult/FlightResult.css";
import { FaCheck } from "react-icons/fa";
import ReactDOMServer from "react-dom/server";
import { IoIosArrowDown, IoIosArrowBack, IoIosClose } from "react-icons/io";
import { FaArrowLeft, FaCalendarAlt, FaFilter } from "react-icons/fa";
import Book from "../Book/Book";
import { MdFlight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import { FaSearch } from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { API_URL2, apiClient2 } from "../../axiosConfig";

const FlightResult = () => {
  const navigate = useNavigate();
  const [isAirlineDropdownOpen, setIsAirlineDropdownOpen] = useState(false);
  const [airlineSearchTerm, setAirlineSearchTerm] = useState("");
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_KEY = "XgJlPqMbKzVnWyDrFtChSuAe";

  // Filter states
  const [selectedTimes, setSelectedTimes] = useState([]);
  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [priceRange, setPriceRange] = useState([5000, 15000]);
  const [selectedDepTimeFilter, setSelectedDepTimeFilter] = useState(null);
  const [selectedArrTimeFilter, setSelectedArrTimeFilter] = useState(null);
  const [durationRange, setDurationRange] = useState([1, 10]);
  const [nonStopOnly, setNonStopOnly] = useState(false);
  const [withStopsOnly, setWithStopsOnly] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showBookComponent, setShowBookComponent] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
  });

  const [formErrors, setFormErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleBookComponent = () => {
    setShowBookComponent(!showBookComponent);
  };
  // Search params state
  const [searchParams, setSearchParams] = useState(() => {
    const storedParams = sessionStorage.getItem("flightSearchParams");
    return storedParams
      ? JSON.parse(storedParams)
      : {
          origin: "LHR",
          destination: "SIN",
          departureDate: "2025-01-05",
          returnDate: "2025-03-15",
          travelers: 1,
          tripType: "one-way",
        };
  });
  // Permanent airline options
  const permanentAirlineOptions = [
    "American Airlines",
    "Air Canada",
    "Delta Air Lines",
    "United Airlines",
    "Virgin Atlantic",
    "British Airways",
    "Lufthansa",
    "Air France",
    "Emirates",
    "KLM Royal Dutch Airlines",
    "Brussels Airlines",
    "Turkish Airlines",
    "Singapore Airlines",
    "Iberia Airlines",
    "Royal Air Maroc",
    "Scandinavian Airlines (SAS)",
    "Etihad Airways",
    "Qatar Airways",
    "Kenya Airways",
    "Icelandair",
    "SWISS International Air Lines",
    "Aeroméxico",
    "ITA Airways (formerly Alitalia)",
    "LATAM Airlines Brasil",
    "Ethiopian Airlines",
    "TAP Air Portugal",
    "Finnair",
    "Cathay Pacific",
    "Aeroflot",
    "SriLankan Airlines",
    "China Southern Airlines",
    "Malaysia Airlines",
    "China Eastern Airlines",
    "Oman Air",
    "Avianca",
    "Gulf Air",
    "Air China",
    "China Airlines",
    "Qantas Airways",
    "Korean Air",
    "Philippine Airlines",
    "Thai Airways International",
    "Vistara",
    "Air India",
    "Austrian Airlines",
    "Rossiya Airlines",
    "Air Mauritius",
    "South African Airways",
    "Vietnam Airlines",
    "Asiana Airlines",
    "Aegean Airlines",
    "Royal Brunei Airlines",
    "EgyptAir",
    "Air New Zealand",
    "Air Europa",
    "Jet Airways",
  ];

  // Dummy data for API fallback
  const dummyFlightData = [
    {
      id: "flight-1",
      airline: "American Airlines",
      airlineCode: "AA",
      airlineLogo: "/aa.png",
      departureAirport: searchParams.origin,
      arrivalAirport: searchParams.destination,
      depTime: "09:15",
      arrTime: "11:30",
      departureDate: new Date(searchParams.departureDate).toLocaleDateString(
        "en-GB",
        { day: "2-digit", month: "short" }
      ),
      arrivalDate: new Date(searchParams.departureDate).toLocaleDateString(
        "en-GB",
        { day: "2-digit", month: "short" }
      ),
      duration: "2h 15m",
      stops: 0,
      price: "6,499",
      tripType: "one-way",
      return: null,
    },
    {
      id: "flight-2",
      airline: "British Airways",
      airlineCode: "BA",
      airlineLogo: "/ba.png",
      departureAirport: searchParams.origin,
      arrivalAirport: searchParams.destination,
      depTime: "14:45",
      arrTime: "17:00",
      departureDate: new Date(searchParams.departureDate).toLocaleDateString(
        "en-GB",
        { day: "2-digit", month: "short" }
      ),
      arrivalDate: new Date(searchParams.departureDate).toLocaleDateString(
        "en-GB",
        { day: "2-digit", month: "short" }
      ),
      duration: "2h 15m",
      stops: 1,
      price: "7,199",
      tripType: "round-trip",
      return: {
        departureAirport: searchParams.destination,
        arrivalAirport: searchParams.origin,
        depTime: "22:00",
        arrTime: "00:15",
        departureDate: new Date(searchParams.returnDate).toLocaleDateString(
          "en-GB",
          { day: "2-digit", month: "short" }
        ),
        arrivalDate: new Date(searchParams.returnDate).toLocaleDateString(
          "en-GB",
          { day: "2-digit", month: "short" }
        ),
        duration: "2h 15m",
        stops: 1,
      },
    },
  ];

  // Handle window resize
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1024);
  };

  // Add event listener for window resize
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Format date for API in MM/DD/YYYY format
  const formatDateForAPI = (dateString) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Fetch flight data from API
  useEffect(() => {
    const storedParams = sessionStorage.getItem("flightSearchParams");
    if (storedParams) {
      try {
        const parsedParams = JSON.parse(storedParams);
        setSearchParams((prev) => {
          const updatedParams = {
            ...parsedParams,
            fromFullName: parsedParams.fromFullName || 
              `${parsedParams.originName || parsedParams.origin} (${parsedParams.origin})`,
            toFullName: parsedParams.toFullName || 
              `${parsedParams.destinationName || parsedParams.destination} (${parsedParams.destination})`,
            classSelected: parsedParams.travelClass || 'Economy',
            returnDateFormatted: parsedParams.returnDate 
              ? new Date(parsedParams.returnDate).toLocaleDateString('en-GB', { 
                  day: '2-digit', 
                  month: 'short', 
                  year: 'numeric' 
                })
              : null
          };
          
          if (JSON.stringify(prev) !== JSON.stringify(updatedParams)) {
            return updatedParams;
          }
          return prev;
        });
        sessionStorage.removeItem("flightSearchParams");
      } catch (err) {
        console.error("Error parsing search params from session storage:", err);
      }
    }
  
    const fetchFlights = async () => {
      setLoading(true);
      setError(null);
      setShowErrorPopup(false); // Reset popup state when starting new fetch
      
      try {
        const apiParams = {
          departure: searchParams.origin,
          destination: searchParams.destination,
          travelDate: formatDateForAPI(searchParams.departureDate),
          isRoundTrip: searchParams.tripType === "round-trip",
          returnDate: searchParams.returnDate
            ? formatDateForAPI(searchParams.returnDate)
            : null,
        };
  
        console.log("API request params:", apiParams);
  
        const response = await apiClient2.get("/flights/search", {
          params: apiParams,
        });
  
        console.log("API Response:", response.data);

        const transformedFlights = Array.isArray(response.data)
          ? response.data.map((flight) => ({
              id: `flight-${Math.random().toString(36).substr(2, 9)}`,
              airline: getAirlineName(flight.airline),
              airlineCode: flight.airline,
              airlineLogo:
                flight.airlineImage ||
                `/airlines/${flight.airline.toLowerCase()}.png`,
              departureAirport: flight.departure.airport,
              arrivalAirport: flight.arrival.airport,
              depTime: flight.departure.time,
              arrTime: flight.arrival.time,
              departureDate: new Date(flight.departure.date).toLocaleDateString(
                "en-GB",
                { day: "2-digit", month: "short" }
              ),
              arrivalDate: new Date(flight.arrival.date).toLocaleDateString(
                "en-GB",
                { day: "2-digit", month: "short" }
              ),
              duration: formatDuration(flight.duration),
              stops: flight.stops,
              price: formatPrice(flight.price),
              tripType: flight.return ? "round-trip" : "one-way",
              return: flight.return
                ? {
                    departureAirport:
                      flight.return.departure?.airport ||
                      searchParams.destination,
                    arrivalAirport:
                      flight.return.arrival?.airport || searchParams.origin,
                    depTime: flight.return.departure?.time || "12:00",
                    arrTime: flight.return.arrival?.time || "14:00",
                    departureDate: flight.return.departure?.date
                      ? new Date(
                          flight.return.departure.date
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })
                      : new Date(searchParams.returnDate).toLocaleDateString(
                          "en-GB",
                          { day: "2-digit", month: "short" }
                        ),
                    arrivalDate: flight.return.arrival?.date
                      ? new Date(flight.return.arrival.date).toLocaleDateString(
                          "en-GB",
                          { day: "2-digit", month: "short" }
                        )
                      : new Date(searchParams.returnDate).toLocaleDateString(
                          "en-GB",
                          { day: "2-digit", month: "short" }
                        ),
                    duration: formatDuration(
                      flight.return.duration || "2h 15m"
                    ),
                    stops: flight.return.stops || 0,
                  }
                : null,
            }))
          : [];

       setFlights(transformedFlights);

        // Only set error and show popup if no flights found in API response
        if (transformedFlights.length === 0) {
          const errorMsg = `No flights found for ${searchParams.origin} to ${searchParams.destination}.`;
          setError(errorMsg);
          setShowErrorPopup(true);
        } else {
          const prices = transformedFlights.map((f) =>
            parseInt(f.price.replace(",", ""))
          );
          const minPrice = Math.min(...prices);
          const maxPrice = Math.max(...prices);
          setPriceRange([minPrice, maxPrice]);
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching flights:", err);
        
        // Check if it's a 404 error
        const is404Error = err.response && err.response.status === 404;
        
        let errorMsg = `Failed to fetch flights: ${err.message}. Please try again later.`;
        
        if (is404Error) {
          errorMsg = `No flights available for ${searchParams.origin} to ${searchParams.destination}.`;
          setShowErrorPopup(true);
        }

        setError(errorMsg);
        setFlights([]);
        setLoading(false);
      }
    };

    fetchFlights();
  }, [searchParams]);

  
  
  useEffect(() => {
    // Custom success icon using React Icons (FaCheck)
    const successIconHTML = `
      <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        background-color: #a5dc86;
        border-radius: 50%;
        margin: 0 auto 10px;
        color: white;
        font-size: 16px;
      ">
        ${ReactDOMServer.renderToString(<FaCheck />)}
      </div>
    `;
  
    if (showErrorPopup && error) {
      Swal.fire({
        html: `
          ${successIconHTML}
          <h3 style="text-align: center; font-weight: 700; margin-bottom: 15px;">For This Destination, Please Contact Our Agents</h3>
          <p>Let our travel experts help you find the best flights for your journey.</p>
          <button class="swal2-confirm swal2-styled" onclick="window.location.href='tel:02039449931'" style="background-color: #f28f33;">
            📞 Call Us: 02039449931
          </button>
        `,
        showConfirmButton: false,
        showCloseButton: true,
        allowOutsideClick: true,
        customClass: {
          popup: 'custom-popup',
          closeButton: 'custom-close-button'
        }
      }).then(() => {
        setShowErrorPopup(false);
      });
    }
  }, [showErrorPopup, error]);
  
  // Add these functions to the component
  const formatDuration = (duration) => {
    // Handle the case where duration is expressed in hours (e.g., "8664h")
    if (typeof duration === "string" && duration.endsWith("h")) {
      const hours = parseInt(duration.replace("h", ""));
      if (hours > 24) {
        // Convert to a more readable format for long durations
        const displayHours = hours % 24;
        const days = Math.floor(hours / 24);
        return days > 0 ? `${days}d ${displayHours}h` : `${hours}h`;
      }
      return duration;
    }
    return duration || "2h 15m"; // Fallback
  };

  const formatPrice = (price) => {
    if (typeof price === "string") {
      // Remove the pound sign if present
      price = price.replace("£", "");

      // Parse the price as a float and round to nearest whole number
      const numericPrice = parseFloat(price);
      if (!isNaN(numericPrice)) {
        return Math.round(numericPrice).toLocaleString();
      }
    }
    return price || "7,500"; // Fallback
  };
  // Helper function to convert airline code to name
  const getAirlineName = (code) => {
    const airlineMap = {
      AA: "American Airlines",
      BA: "British Airways",
      DL: "Delta Air Lines",
      UA: "United Airlines",
      LH: "Lufthansa",
      AF: "Air France",
      KL: "KLM Royal Dutch Airlines",
      EK: "Emirates",
      QR: "Qatar Airways",
      VS: "Virgin Atlantic",
      AT: "Royal Air Maroc",
      AS: "Alaska Airlines",
      WN: "Southwest Airlines",
      B6: "JetBlue Airways",
      AC: "Air Canada",
      NH: "All Nippon Airways",
      SQ: "Singapore Airlines",
      CX: "Cathay Pacific",
      EY: "Etihad Airways",
      TK: "Turkish Airlines",
      "9W": "Jet Airways",
    };
    return airlineMap[code] || code;
  };

  // Get unique times for filtering
  const timeOptions = flights.length
    ? [...new Set(flights.map((flight) => flight.depTime))]
    : [];

  // Handle time selection
  const handleTimeSelection = (time) => {
    setSelectedTimes((prev) =>
      prev.includes(time) ? prev.filter((t) => t !== time) : [...prev, time]
    );
  };

  // Handle airline selection
  const handleAirlineSelection = (airline) => {
    setSelectedAirlines((prev) =>
      prev.includes(airline)
        ? prev.filter((a) => a !== airline)
        : [...prev, airline]
    );
  };

  // Toggle non-stop filter
  const toggleNonStop = () => {
    setNonStopOnly(!nonStopOnly);
    if (!nonStopOnly) {
      setWithStopsOnly(false);
    }
  };

  // Toggle with stops filter
  const toggleWithStops = () => {
    setWithStopsOnly(!withStopsOnly);
    if (!withStopsOnly) {
      setNonStopOnly(false);
    }
  };

  // Reset current filter
  // Function to display stop text based on number of stops
  const getStopText = (stops) => {
    switch (stops) {
      case 0:
        return "non-stop";
      case 1:
        return "1 stop";
      default:
        return `${stops} stops`;
    }
  };

  // Fix the resetFilter function
  const resetFilter = () => {
    setSelectedTimes([]);
    setSelectedAirlines([]);

    // Reset price range based on available flights
    if (flights.length > 0) {
      const prices = flights.map((f) => parseInt(f.price.replace(/,/g, "")));
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      setPriceRange([minPrice, maxPrice]);
    } else {
      setPriceRange([5000, 15000]);
    }

    setSelectedDepTimeFilter(null);
    setSelectedArrTimeFilter(null);

    // Use a more generous duration range to ensure flights aren't filtered out
    setDurationRange([0, 50]); // Allow for flights from 0 to 50 hours

    setNonStopOnly(false);
    setWithStopsOnly(false);
  };

  // Improve the duration extraction in filteredFlights filter
  // In your filteredFlights filter logic, make sure selected airline check is done consistently:

  const filteredFlights = flights.filter((flight) => {
    // Apply all non-airline filters first

    // Stop filters
    if (nonStopOnly && flight.stops !== 0) return false;
    if (withStopsOnly && flight.stops === 0) return false;

    // Time filters
    if (selectedTimes.length && !selectedTimes.includes(flight.depTime))
      return false;

    // Price filters
    const numericPrice = parseInt(flight.price.replace(/,/g, ""));
    if (numericPrice < priceRange[0] || numericPrice > priceRange[1])
      return false;

    // *** Apply airline filter LAST, and only if airlines are selected ***
    if (
      selectedAirlines.length > 0 &&
      !selectedAirlines.includes(flight.airline)
    ) {
      return false;
    }

    return true;
  });

  // Initialize duration range to be more lenient
  useEffect(() => {
    // Initialize with lenient defaults to show all flights initially
    setDurationRange([0, 50]);
  }, []);

  const handleSearch = (searchData) => {
    console.log("Search data received:", searchData);
    
    setSearchParams({
      origin: searchData.origin,
      destination: searchData.destination,
      departureDate: searchData.departureDate,
      returnDate: searchData.returnDate,
      travelers: searchData.travelers,
      tripType: searchData.tripType,
    });
    setLoading(true);
    setShowBookComponent(false); 
    
  };

  
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Close sidebar
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  // Create a new function to get flights filtered by everything except airlines
  const getFlightsWithoutAirlineFilter = () => {
    return flights.filter((flight) => {
      // Copy all filtering logic except airline filter
      if (nonStopOnly && flight.stops !== 0) return false;
      if (withStopsOnly && flight.stops === 0) return false;

      if (selectedTimes.length && !selectedTimes.includes(flight.depTime))
        return false;

      const numericPrice = parseInt(flight.price.replace(/,/g, ""));
      if (numericPrice < priceRange[0] || numericPrice > priceRange[1])
        return false;

      // Add the rest of your filters but NOT the airline filter

      return true;
    });
  };

  const getFlightsFilteredExceptAirlines = () => {
    return flights.filter((flight) => {
      // Apply all filters EXCEPT airline filter
      if (nonStopOnly && flight.stops !== 0) return false;
      if (withStopsOnly && flight.stops === 0) return false;

      if (selectedTimes.length && !selectedTimes.includes(flight.depTime))
        return false;

      const numericPrice = parseInt(flight.price.replace(/,/g, ""));
      if (numericPrice < priceRange[0] || numericPrice > priceRange[1])
        return false;

      // Skip the airline filter
      // if (selectedAirlines.length > 0 && !selectedAirlines.includes(flight.airline)) return false;

      let durationHours = 0;
      if (typeof flight.duration === "string") {
        // Your existing duration parsing logic
        if (flight.duration.includes("d")) {
          const parts = flight.duration.split("d");
          const days = parseInt(parts[0].trim());
          durationHours = days * 24;

          if (parts[1] && parts[1].includes("h")) {
            const hours = parseInt(parts[1].replace("h", "").trim());
            durationHours += hours;
          }
        } else if (flight.duration.includes("h")) {
          const hourPart = flight.duration.split("h")[0].trim();
          durationHours = parseInt(hourPart);

          if (flight.duration.includes("m")) {
            const minPart = flight.duration.split("h")[1].split("m")[0].trim();
            const minutes = parseInt(minPart);
            if (!isNaN(minutes)) {
              durationHours += minutes / 60;
            }
          }
        }
      }

      if (
        !isNaN(durationHours) &&
        (durationHours < durationRange[0] || durationHours > durationRange[1])
      )
        return false;

      if (selectedDepTimeFilter) {
        const depTime = parseInt(flight.depTime.split(":")[0]);
        switch (selectedDepTimeFilter) {
          case "night":
            if (!(depTime >= 0 && depTime < 6)) return false;
            break;
          case "morning":
            if (!(depTime >= 6 && depTime < 12)) return false;
            break;
          case "afternoon":
            if (!(depTime >= 12 && depTime < 18)) return false;
            break;
          case "evening":
            if (!(depTime >= 18 && depTime < 24)) return false;
            break;
          default:
            break;
        }
      }

      if (selectedArrTimeFilter) {
        const arrTime = parseInt(flight.arrTime.split(":")[0]);
        switch (selectedArrTimeFilter) {
          case "night":
            if (!(arrTime >= 0 && arrTime < 6)) return false;
            break;
          case "morning":
            if (!(arrTime >= 6 && arrTime < 12)) return false;
            break;
          case "afternoon":
            if (!(arrTime >= 12 && arrTime < 18)) return false;
            break;
          case "evening":
            if (!(arrTime >= 18 && arrTime < 24)) return false;
            break;
          default:
            break;
        }
      }

      return true;
    });
  };
  // Then in your render function:
  const availableFlights = getFlightsWithoutAirlineFilter();
  const availableAirlines = Array.from(
    new Set(availableFlights.map((flight) => flight.airline))
  ).sort();

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "firstName":
      case "lastName":
        if (!value.trim()) {
          error = `${name === "firstName" ? "First" : "Last"} name is required`;
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          error = "Only alphabets are allowed";
        }
        break;

      case "email":
        if (!value.trim()) {
          error = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = "Please enter a valid email address";
        }
        break;

      case "contact":
        if (!value.trim()) {
          error = "Contact number is required";
        } else if (!/^\d+$/.test(value)) {
          error = "Only numbers are allowed";
        } else if (value.length < 6 || value.length > 15) {
          error = "Must be between 6-15 digits";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Real-time validation
    const error = validateField(name, value);
    setFormErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const isFormValid = () => {
    // Check if any field is empty
    const hasEmptyFields = Object.values(formData).some(
      (val) => val.trim() === ""
    );

    // Check if any field has errors
    const hasErrors = Object.values(formErrors).some((error) => error !== "");

    return !hasEmptyFields && !hasErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Final validation before submission
    const newErrors = {};
    let isValid = true;

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      newErrors[key] = error;
      if (error) isValid = false;
    });

    setFormErrors(newErrors);

    if (!isValid) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fix the errors in the form",
      });
      return;
    }

    // Submit form if valid
    setIsSubmitting(true);

    // Prepare template parameters for EmailJS
    const templateParams = {
      from_name: `${formData.firstName} ${formData.lastName}`,
      from_email: formData.email,
      contact_number: formData.contact,
      message: `Flight Enquiry for ${searchParams.origin} to ${
        searchParams.destination
      } on ${new Date(searchParams.departureDate).toLocaleDateString()}`,
      trip_type: searchParams.tripType,
      travelers: searchParams.travelers,
    };

    try {
      // Replace with your EmailJS service ID, template ID, and user ID
      await emailjs.send(
        "service_src72qi", // Replace with your EmailJS service ID
        "template_utxpfp5", // Replace with your EmailJS template ID
        templateParams,
        "X5UqVmxpTiGClhNfI" // Replace with your EmailJS user ID
      );

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Enquiry Submitted",
        text: "We will contact you shortly!",
        timer: 3000,
      });

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        contact: "",
      });
    } catch (error) {
      console.error("Email sending failed:", error);

      Swal.fire({
        icon: "error",
        title: "Failed to Send",
        text: "Something went wrong. Please try again or call us directly.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const callAdmin = () => {
    window.location.href = "tel:02039449931";
  };

  // Render loading state
  // Render loading state
if (loading) {
  return (
    <div className="flight-result">
      <div className="loading-container">
        <Spinner />
      </div>
    </div>
  );
}

// Main render when not loading
return (
  <div className="flight-result">
    {/* Book component - shown only when showBookComponent is true */}
    {showBookComponent && (
      <div className="book-wrapper show">
        <div className="book-header">
          <IoIosClose 
            className="book-close-icon" 
            onClick={toggleBookComponent} 
          />
        </div>
        <Book 
          onSearch={(searchData) => {
            handleSearch(searchData);
            setShowBookComponent(false);
          }} 
        />
      </div>
    )}

    {/* Header section */}
    <div className="flight-header">
      {isMobile ? (
        <FaFilter 
          className="filter-icon-mobile" 
          onClick={toggleSidebar} 
        />
      ) : (
        <IoIosArrowBack
          className="back-icon"
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer" }}
        />
      )}
      <div className="d-d">
        <h2>
          {searchParams.fromFullName ||
            `${searchParams.originName} (${searchParams.origin})`}{" "}
          -{" "}
          {searchParams.toFullName ||
            `${searchParams.destinationName} (${searchParams.destination})`}
        </h2>
        <p>
          <strong>Journey Date:</strong>{" "}
          {searchParams.departureDateFormatted || 
            new Date(searchParams.departureDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          {searchParams.returnDate && (
            <>
              {" "}
              | <strong>Return Date:</strong>{" "}
              {searchParams.returnDateFormatted ||
                new Date(searchParams.returnDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
            </>
          )}{" "}
          | {searchParams.travelers} Traveller
          {searchParams.travelers > 1 ? "s" : ""}
          {searchParams.classSelected && ` | ${searchParams.classSelected}`}
        </p>
        <FaSearch 
          className="search-icon" 
          onClick={toggleBookComponent} 
        />
      </div>
    </div>

      {/* Main Content */}
      <div className="main-content">
        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          {/* Sidebar with Filters */}
          <IoIosClose className="close-icon-mobile" onClick={closeSidebar} />
          <div className="available-container">
          <h4>Flights Available</h4>
          <p>({filteredFlights.length} flights Found)</p>
          </div>
          <div className="filter-section-fll">
         
  <h4>Airlines</h4>
  
  {/* Search bar for airlines */}
  <div className="search-container-fll">
    <input
      type="text"
      placeholder="Search airlines..."
      value={airlineSearchTerm}
      onChange={(e) => setAirlineSearchTerm(e.target.value)}
      className="airline-search-input-fll"
    />
  </div>
  
  {/* Checkbox list for airlines */}
  <div className="airlines-checkbox-list-fll">
    {availableAirlines.length === 0 ? (
      <p className="no-airlines-fll">
        No airlines available with current filters
      </p>
    ) : (
      availableAirlines
        .filter((airline) =>
          airline
            .toLowerCase()
            .includes(airlineSearchTerm.toLowerCase())
        )
        .map((airline) => (
          <div key={airline} className="airline-checkbox-item-fll">
            <div className="checkbox-container-fll">
              <input
                type="checkbox"
                id={`airline-${airline}`}
                checked={selectedAirlines.includes(airline)}
                onChange={() => handleAirlineSelection(airline)}
              />
              <label htmlFor={`airline-${airline}`}>
                {airline}
              </label>
            </div>
          </div>
        ))
    )}
  </div>
  
  {/* Selected count and clear button */}
  {availableAirlines.length > 0 && (
    <div className="airlines-selection-controls-fll">
      <span>{selectedAirlines.length} airlines selected</span>
      {selectedAirlines.length > 0 && (
        <button
          className="clear-selection-fll"
          onClick={() => setSelectedAirlines([])}
        >
          Clear All
        </button>
      )}
    </div>
  )}
</div>

          {/* Price Filter 
          <div className="filter-section">
            <h4>Price Range</h4>
            <div className="price-range">
              <p>
                £{priceRange[0]} - £{priceRange[1]}
              </p>
            </div>
            <input
              type="range"
              min={
                flights.length > 0
                  ? Math.min(
                      ...flights.map((f) => parseInt(f.price.replace(",", "")))
                    )
                  : 5000
              }
              max={
                flights.length > 0
                  ? Math.max(
                      ...flights.map((f) => parseInt(f.price.replace(",", "")))
                    )
                  : 20000
              }
              value={priceRange[0]}
              onChange={(e) =>
                setPriceRange([parseInt(e.target.value), priceRange[1]])
              }
            />
          </div>
          */}
          {/* Replace your current enquiry-form div with this updated version 
          <div className="enquiry-form">
            <h4>Fill Enquiry Form</h4>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  placeholder="Enter first name"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
                {formErrors.firstName && (
                  <p className="error-text">{formErrors.firstName}</p>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Enter last name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
                {formErrors.lastName && (
                  <p className="error-text">{formErrors.lastName}</p>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                {formErrors.email && (
                  <p className="error-text">{formErrors.email}</p>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="contact">Contact Number</label>
                <input
                  type="tel"
                  id="contact"
                  name="contact"
                  placeholder="Enter contact number"
                  value={formData.contact}
                  onChange={handleInputChange}
                />
                {formErrors.contact && (
                  <p className="error-text">{formErrors.contact}</p>
                )}
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={!isFormValid() || isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
          */}

          <div className="help-desk-box">
            <h4>Questions about your flight?</h4>
            <div className="help-desk-content">
              <div className="call-info" onClick={callAdmin}>
                <span className="call-icon">📞</span>
                <p>02039449931</p>
              </div>
            </div>
          </div>

          {/*----------
          <div className="filter-section">
            <h4>Departure Time</h4>
            <div className="time-filter-cards">
              {[
                { label: '00:00 - 06:00', value: 'night' },
                { label: '06:00 - 12:00', value: 'morning' },
                { label: '12:00 - 18:00', value: 'afternoon' },
                { label: '18:00 - 24:00', value: 'evening' },
              ].map((filter) => (
                <div
                  key={filter.value}
                  className={`time-filter-card ${selectedDepTimeFilter === filter.value ? 'selected' : ''}`}
                  onClick={() => setSelectedDepTimeFilter(selectedDepTimeFilter === filter.value ? null : filter.value)}
                >
                  <p>{filter.label}</p>
                </div>
              ))}
            </div>
            <h4>Arrival Time</h4>
            <div className="time-filter-cards">
              {[
                { label: '00:00 - 06:00', value: 'night' },
                { label: '06:00 - 12:00', value: 'morning' },
                { label: '12:00 - 18:00', value: 'afternoon' },
                { label: '18:00 - 24:00', value: 'evening' },
              ].map((filter) => (
                <div
                  key={filter.value}
                  className={`time-filter-card ${selectedArrTimeFilter === filter.value ? 'selected' : ''}`}
                  onClick={() => setSelectedArrTimeFilter(selectedArrTimeFilter === filter.value ? null : filter.value)}
                >
                  <p>{filter.label}</p>
                </div>
              ))}
            </div>
          </div>

        
          <div className="filter-section">
            <h4>Duration</h4>
            <div className="duration-range">
              <p>{durationRange[0]}h - {durationRange[1]}h</p>
              <input
                type="range"
                min="1"
                max="10"
                value={durationRange[0]}
                onChange={(e) => setDurationRange([parseInt(e.target.value), durationRange[1]])}
              />
            </div>
          </div>

         
          <div className="filter-section">
            <h4>Stops</h4>
            <div className="stop-options">
              <div className="filter-option">
                <input
                  type="checkbox"
                  id="non-stop"
                  checked={nonStopOnly}
                  onChange={toggleNonStop}
                />
                <label htmlFor="non-stop">Non-stop only</label>
              </div>
              <div className="filter-option">
                <input
                  type="checkbox"
                  id="with-stops"
                  checked={withStopsOnly}
                  onChange={toggleWithStops}
                />
                <label htmlFor="with-stops">With stops only</label>
              </div>
            </div>
          </div>
          ------ */}

          {/* Airline Filter - Now showing permanent airlines regardless of flight data */}
          {/* Airline Filter - Now showing only airlines available after other filters are applied */}

          <div className="but-div">
            <button className="reset-btn" onClick={resetFilter}>
              Reset Filters
            </button>
          </div>
        </div>
        <div className="content-div">
          {/* Date Selection Bar --
          <div className="date-bar">
            <div className="date-scroll">
              {flights.length > 0 && [...Array(20)].map((_, index) => {
                // Use UTC dates to avoid timezone issues
                const baseDate = new Date(searchParams.departureDate);
                
                // Calculate the date for this item
                const date = new Date(baseDate);
                date.setDate(baseDate.getDate() + index);
                
                // Format for display
                const day = date.getDate();
                const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()];
                
                // Format for comparison (YYYY-MM-DD)
                const dateString = date.toISOString().split('T')[0];
                
                // Check if this is the currently selected date (index 0)
                const isSelected = index === 0;
                
                // Generate a price
                const price = 6000 + index * 100;
                
                return (
                  <div 
                    key={index} 
                    className={`date-item ${isSelected ? "selected" : ""}`}
                    onClick={() => {
                      // Update search params with the clicked date
                      setSearchParams({
                        ...searchParams,
                        departureDate: dateString
                      });
                    }}
                  >
                    <p>{day}, {weekday}</p>
                    <span>£ {price}</span>
                  </div>
                );
              })}
            </div>
          </div>

*/}

          {/* Flight List */}
          <div className="flight-list">
            {filteredFlights.length > 0 ? (
              filteredFlights.map((flight) => (
                <div key={flight.id} className="flight-card">
                  {/* Outbound Flight */}
                  <div className="flight-info">
                    <div className="fd">
                      <div className="airline-info">
                        <img
                          src={flight.airlineLogo || "/aa.png"}
                          alt={flight.airline}
                          className="airline-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/aa.png"; // Default image if airline logo fails to load
                          }}
                        />
                        <span className="airline-code">{flight.airline}</span>
                      </div>
                      <div className="flight-time-info">
                        {/*-
                        <p className="time">{flight.depTime}</p>
                        -*/}
                        <p className="airport-code">
                          {flight.departureAirport || searchParams.origin}
                        </p>
                        {/*-
                        <p className="date">{flight.departureDate}</p>
                         -*/}
                      </div>
                      <div className="flight-duration">
                        <div className="flight-line">
                          <div className="stop-indicator">
                            <span className="stop-do">
                              <MdFlight className="flogo" />
                            </span>
                          </div>
                        </div>
                        {/*-
                        <p className="duration">{flight.duration}</p>
                        <p className="stops">{getStopText(flight.stops)}</p>
                        -*/}
                      </div>
                      <div className="flight-time-info">
                        {/*-
                        <p className="time">{flight.arrTime}</p>
                        -*/}
                        <p className="airport-code">
                          {flight.arrivalAirport || searchParams.destination}
                        </p>
                        {/*-  <p className="date">{flight.arrivalDate}</p>  -*/}
                      </div>
                    </div>
                    {/* Return Flight (only for round-trip) */}
                    {searchParams.tripType === "round-trip" &&
                      flight.return && (
                        <div className="flight-info">
                          <div className="fd fdd">
                            <div className="airline-info">
                              <img
                                src={flight.airlineLogo || "/aa.png"}
                                alt={flight.airline}
                                className="airline-logo"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/aa.png"; // Default image if airline logo fails to load
                                }}
                              />
                              <span className="airline-code">
                                {flight.airline}
                              </span>
                            </div>
                            <div className="flight-time-info">
                              {/*-
                            <p className="time">{flight.return.depTime}</p>
                            -*/}
                              <p className="airport-code">
                                {flight.return.departureAirport ||
                                  searchParams.destination}
                              </p>
                              {/*-
                            <p className="date">{flight.return.departureDate}</p>
                             -*/}
                            </div>
                            <div className="flight-duration">
                              <div className="flight-line">
                                <div className="stop-indicator">
                                  <span className="stop-do">
                                    <MdFlight className="flogoo" />
                                  </span>
                                </div>
                              </div>
                              {/*-
                            <p className="duration">{flight.return.duration}</p>
                            <p className="stops">{getStopText(flight.return.stops)}</p>
                            -*/}
                            </div>
                            <div className="flight-time-info">
                              {/*-
                            <p className="time">{flight.return.arrTime}</p>
                            -*/}
                              <p className="airport-code">
                                {flight.return.arrivalAirport ||
                                  searchParams.origin}
                              </p>
                              {/*-
                            <p className="date">{flight.return.arrivalDate}</p>
                            -*/}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>

                  <div className="price-div">
                    <div className="trip-type-tag">
                      {searchParams.tripType === "round-trip"
                        ? "Round Trip"
                        : "One Way"}
                    </div>
                    <p className="flight-price">£ {flight.price}</p>
                    <button className="button-42" onClick={callAdmin}>
                      Call Now <hr/> 020 3944 9931
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-results">
                No flights available for the selected filters.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlightResult;
